const prodAPI = "https://app.872813.com";
const devAPI = "http://localhost:3005";

let api = prodAPI;

if (process.env.REACT_APP_NODE_ENV === "dev") api = devAPI;

export default api;
